export default "__VITE_ASSET__DpzfbEzY__"